import React from 'react';
import { Form, Icon, Input, Select, Checkbox, Row, Col } from 'antd';
import Label from '../widgets/Label';
import Lang from '../widgets/Lang';


const formItemLayout = {
  labelCol  : { xs: { span: 24 }, sm: { span: 6 }, },
  wrapperCol: { xs: { span: 24 }, sm: { span: 18 }, },
};

const { Option } = Select;

/** Компонента, которая обеспечивает одновременный ввод наименование и языка */
class LabelInput extends React.Component {

  handleLabelChange = e => {
    this.triggerChange({text: e.target.value });
  };

  handleLangChange = lang => {
    this.triggerChange({ lang });
  };

  triggerChange = changedValue => {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  render() {
    const { value } = this.props;
    return (
      <Row gutter={8}>
        <Col span={20}>
          <Input prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />} type="text" value={value.text} onChange={this.handleLabelChange} placeholder="Наименование"/>
        </Col>
        <Col span={4}>
          <Select
            value={value.lang}
              onChange={this.handleLangChange}>
            <Option value="ru">ru</Option>
            <Option value="en">en</Option>
          </Select>
        </Col>
      </Row>
    );
  }
}

/** Форма добавления нового элемента
 * Обязательно указать IRI.
 * Для указания наименования необходимо определить предикат. 
 */
class NewAdmsElementForm extends React.Component {

  state = {
    EP:"2021",
    iri: "http://www.w3.org/ns/adms#",
  };

  handleIRIChange = e => {
    const value = e.target.value;
    const iri = (value && (value.startsWith("http://") || value.startsWith("https://")))? value : "http://www.w3.org/ns/adms#"+e.target.value;
    this.setState({iri});
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
        <Form {...formItemLayout} className="ant-edit-form">
          <Form.Item label="IRI" extra={this.state.iri}>
            {getFieldDecorator('IRI', {
              rules: [{ required: true, message: 'Пожалуйста, укажите IRI!' }],
            })(
              <Input prefix={<Icon type="shrink" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="IRI" onChange={this.handleIRIChange}/>,
            )}
          </Form.Item>
          <Form.Item label={<Label />}>
            {getFieldDecorator('label', {
                  initialValue: { text: "", lang: 'ru' },
                  rules: [{ required: true, message: 'Пожалуйста, укажите наименование!' }],
            })( <LabelInput />)}
          </Form.Item>
          <Form.Item label={<Label iri="http://www.w3.org/1999/02/22-rdf-syntax-ns#type" />}>
            {getFieldDecorator('type', {
                  initialValue: "http://www.w3.org/ns/dcat#Dataset",
                  rules: [{ required: true, message: 'Пожалуйста, выберите тип!' }],
            })( 
              <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Тип элемента" disabled/>,
            )}
          </Form.Item>
        </Form>
    );
  }
}

export default Form.create({ name: 'new_adms_element' })(NewAdmsElementForm);